<template>
  <div class="divs">
    <g-menu-sidebar
      class="menusidebar"
      titulofechado="Gerar Carta-Proposta"
      tituloaberto="Resumo"
    >

      <template #conteudo>
        <div class="titulo-icone-parametros">
            <img
              class="img-resumo-parametros-web"
              src="@/assets/imgs/icone_parametros.svg"
            />
          <div class="titulo-topico">Parâmetros</div>
        </div>
        <div class="resumo-step1">
          <div class="parametros-tipo">
            <div class="titulo"> Unidade </div>
            <div class="conteudo">{{step1.nomeEmpresa}}</div>
          </div>
          <div class="parametros-representante">
            <div class="titulo"> Representante </div>
            <div class="conteudo">{{step1.nomeRepresentante}}</div>
          </div>
          <div class="alinha-resumo">
                <div class="parametros-unidade">
                  <div class="titulo"> Cliente </div>
                  <div class="conteudo">{{step1.nomeFantasia}}</div>
                </div>
          </div>
        </div>
        <div v-if="steps >= 1"  class="grupo-orcamento">
            <hr>
            <div class="titulo-icone-parametros">
                <img
                class="img-resumo-parametros-web"
                src="@/assets/imgs/icone_orçamentos.svg"
              />
              <div class="titulo-topico"> Orçamento </div>
            </div>
            <div :key="data.id" class="alinha-resumo div-orcamento conteudo d-flex" v-for="data in step2">
              <div>
                <div class="titulo"> Orçamentos </div>      
                <div>{{data.codigoOrcamento}}</div>
              </div>
              <div>
                <div class="titulo"> Nome Produto </div>
                <div>{{data.nomeProduto}}</div>
              </div>
            </div>  
        </div>
        <div v-if="steps >= 2"  class="resumo-step1 grupo-pagamento">
            <hr>
            <div class="titulo-icone-parametros">
              <img
              class="img-resumo-parametros-web"
              src="@/assets/imgs/icone_pagamento.svg"
            />
              <div class="titulo-topico"> Pagamento </div>
            </div>
            <div class="alinha-resumo conteudo d-flex">
              <div>
                <div class="titulo"> Forma de pag. </div>      
                <div>{{step3.formaPagamento}}</div>
              </div>
              <div>
                <div class="titulo"> Tipo de Carta </div>
                <div>{{step3.tipoCartaPropostaEnum}}</div>
              </div>
            </div>  
          </div>
      </template>
    </g-menu-sidebar>


    <g-card
      :temCabecalho="false"
    >


      <g-steps @RouterIndex="verificarTabs" :items="items" :metadeLargura="true"></g-steps>


    </g-card>

    <g-card-resumo
      class="resumoorcamento"
      titulofechado="RESUMO DA CARTA-PROPOSTA"
      tituloaberto="RESUMO DA CARTA-PROPOSTA"
    >
      <div class="conteudo-card-resumo">
          <div class="grupo parametros">
            <div class="titulo-icone-parametros margin-resumo">
              <img
              class="img-resumo-parametros-web"
              src="@/assets/imgs/icone_parametros.svg"
            />
              <div class="titulo-topico"> Parâmetros </div>
            </div>

            <div class="topico topico-parametros">
              <div class="alinha-resumo">
                  <div class="parametros-tipo">
                    <div class="titulo"> Unidade </div>
                    <div class="conteudo">{{step1.nomeEmpresa}}</div>
                  </div>
                  <div class="parametros-representante">
                    <div class="titulo"> Representante </div>
                    <div class="conteudo">{{step1.nomeRepresentante}}</div>
                  </div>
              </div>
              <div class="alinha-resumo">
                  <div class="parametros-unidade">
                    <div class="titulo"> Cliente </div>
                    <div class="conteudo">{{step1.nomeFantasia}}</div>
                  </div>
              </div>
            </div>
          </div>
          <div v-if="steps >= 1"  class="grupo-orcamento">
            <hr>
            <div class="titulo-icone-parametros">
              <img
              class="img-resumo-parametros-web"
              src="@/assets/imgs/icone_orçamentos.svg"
            />
            <div class="titulo-topico"> Orçamento </div>
            </div>
            <div :key="data.orcamentoId" class="alinha-resumo conteudo d-flex" v-for="data in step2">
              <div>
                <div class="titulo"> Orçamentos </div>      
                <div>{{data.codigoOrcamento}}</div>
              </div>
              <div>
                <div class="titulo"> Nome Produto </div>
                <div>{{data.nomeProduto}}</div>
              </div>
            </div>  
          </div>
          <div v-if="steps >= 2"  class="grupo-pagamento">
            <hr>
            <div class="titulo-icone-parametros">
              <img
              class="img-resumo-parametros-web"
              src="@/assets/imgs/icone_pagamento.svg"
            />
              <div class="titulo-topico"> Pagamento </div>
            </div>
            <div class="alinha-resumo conteudo d-flex">
              <div>
                <div class="titulo"> Forma de pag. </div>      
                <div>{{step3.formaPagamento}}</div>
              </div>
              <div>
                <div class="titulo"> Tipo de Carta </div>
                <div>{{step3.tipoCartaPropostaEnum}}</div>
              </div>
            </div>  
          </div>
      </div>  
    </g-card-resumo>


  </div>
</template>

<script>
import GerarCartaProposta from "./GerarCartaProposta.js";
export default GerarCartaProposta;
</script>

<style scoped>
.resumo-step1 {
  margin-left: 5%
}
.img-resumo-parametros-web {
  width: 18px;
}
.margin-resumo {
  margin-top: 25px;
}
.alinha-resumo {
  display: flex;
  gap: 40px;
}
.titulo {
  color: #3e3e3e;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 500;
}
.conteudo {
  color: #8a8a8a;
  text-align: left;
  font-family: "MontSerrat";
}
.titulo-topico {
  padding-left: 8px;
}
.titulo-icone, .titulo-icone-parametros {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: bold;
  display: flex;
  align-items: center;
  font-size: 18px;
}
.resumoorcamento {
  display: none;
}

.Card-Principal {
  margin: 15px auto;
}
.g-steps {
  height: 100%;
}
.conteudo-cabecalho {
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-items: center;
  padding: 5px;
}

.TituloResumo {
  font-family: "MontSerrat";
  color: white;
  font-size: 20px;
  padding: 9px;
}

.tituloeicone {
  display: flex;
  justify-content: space-between;
}

.titulo-container {
  display: flex;
  justify-content: space-between;
}
:deep(.p-sidebar .p-sidebar-header) {
  padding: 0.5rem;
}
.resumo-parametros {
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 18px;
  margin-left: -39px;
  padding: 9px;
}
.img-resumo-parametros {
  margin-left: 22%;
  width: 18px;
  margin-top: 17%;
}
.hr_linha {
  width: 90%;
  margin-left: 5%;
}
/* .resumo-orcamento {
  font-family: "MontSerrat";
  color: #2c2c2c;
  font-size: 14px;
  font-weight: 600;
  margin-left: 5%;
  padding: 9px;
} */

.resumo-orcamento-resultado {
  font-family: "MontSerrat";
  color: #535353;
  font-size: 14px;
  margin-left: 5%;
  margin-top: -20px;
  padding: 9px;
}

.resumo-representante {
  font-family: "MontSerrat";
  color: #2c2c2c;
  font-weight: 600;
  font-size: 14px;
  margin-left: 8%;
  padding: 9px;
}

.resumo-representante-resultado {
  font-family: "MontSerrat";
  color: #535353;
  font-size: 14px;
  margin-left: 8%;
  margin-top: -20px;
  padding: 9px;
}

.div-orcamento {
  background-color: #f1f1f1;
  width: 90%;
  border-radius: 10px 10px;
  margin-left: 5%;
}

.resumo-nome-produto {
  font-family: "MontSerrat";
  color: #2c2c2c;
  font-weight: 600;
  font-size: 14px;
  margin-left: 19%;
  padding: 9px;
}

.resumo-orcamento-parte {
  font-family: "MontSerrat";
  color: #2c2c2c;
  font-weight: 600;
  font-size: 14px;
  margin-left: 2%;
  padding: 9px;
}
.resumo-nome-produto-resultado {
  font-family: "MontSerrat";
  color: #535353;
  font-size: 14px;
  margin-left: 10%;
  margin-top: -20px;
  padding: 9px;
}
.resumo-numeracao {
  font-family: "MontSerrat";
  color: #2c2c2c;
  font-weight: 600;
  font-size: 14px;
  margin-left: -5%;
  margin-top: 3%;
  padding: 9px;
}

@media (min-width: 310px) {
}

@media (min-width: 368px) {
}

@media (min-width: 600px) {
}

@media (min-width: 801px) {
}

@media (min-width: 1025px) {
  .menusidebar {
    display: none;
  }

  .divs {
    display: flex;
    justify-content: space-between;
  }

  .resumoorcamento {
    display: inline;
  }
}

@media (min-width: 1281px) {
}
</style>
